import { ListboxOption } from "@headlessui/react";
import React, { Fragment } from "react";

type option = {
  id: string | number;
  title: string;
  description: string;
  function: () => void;
};

type OptionsBrandedProps = {
  option: option;
};

export const OptionsBranded: React.FC<OptionsBrandedProps> = ({ option }) => (
  <Fragment>
    <ListboxOption
      key={option.title}
      value={option}
      onClick={option.function}
      className="group cursor-default select-none p-4 text-sm text-gray-900 data-[focus]:bg-primary data-[focus]:text-white hover:bg-primary"
    >
      <div className="flex flex-col">
        <div className="flex justify-between">
          <p className="font-normal group-data-[selected]:font-semibold">
            {option.title}
          </p>
        </div>
        <p className="mt-2 text-gray-500 group-data-[focus]:text-indigo-200">
          {option.description}
        </p>
      </div>
    </ListboxOption>
  </Fragment>
);
